import { Input, Select, DatePicker } from 'antd';
import { FilterBar, Button, FormItem, } from 'asumsi-components';
import React from 'react';
import { Link } from 'react-router-dom';

const Search = Input.Search;
const { RangePicker } = DatePicker;
export default function (props: any) {
    const { onSearch, onChangeStatus, onChangeDateRange, dataListTopic, onChangeTopic } = props;
    const { Option } = Select;

    const optionsTopics = dataListTopic ? dataListTopic.map((tp: any) => <Option key={tp.id} value={tp.id}>{tp.name}</Option>) : null;
    const changeTopic = (value: string) => {
        onChangeTopic(value);
    }

    const change = (value: string) => {
        onChangeStatus(value);
    }

    const changeDateRange = (range: any) => {
        let param = '';
        if (range.length) {
            param = `${range[0].format('YYYY-MM-DD')} 00:00|${range[1].format('YYYY-MM-DD')} 23:59`
        }
        onChangeDateRange(param);
    }

    return (
        <FilterBar>
            <FormItem>
                <Search onSearch={onSearch} allowClear={false} placeholder="Masukan kata kunci..." />
            </FormItem>
            <FormItem className="pl-8" >
                <RangePicker onChange={changeDateRange} format="DD MMM YYYY"></RangePicker>
            </FormItem>
            <FormItem className="pl-8" >
                <Select
                    showSearch
                    style={{ width: "100%" }}
                    onChange={changeTopic}
                    allowClear={true}
                    optionFilterProp="children"
                    placeholder="Filter topic">
                    {optionsTopics}
                </Select>
            </FormItem>
            <FormItem className="pl-8">
                <Select
                    style={{ width: "50%" }}
                    onChange={change}
                    allowClear={false}
                    optionFilterProp="children"
                    placeholder="Pilih Status">
                    <Option key="all" value={""}>All</Option>
                    <Option key="draft" value={"draft"}>Draft</Option>
                    <Option key="published" value={"published"}>Published</Option>
                    <Option key="unpublished" value={"unpublished"}>Un Published</Option>
                </Select>
            </FormItem>
            <FormItem className="asumsi-filter-bar__right max-w-20">
                <Link to="posts/form">
                    <Button className="float-right" type="primary" iconLeft="plus" size="medium" text="Tambah" />
                </Link>
            </FormItem>
        </FilterBar>
    );
}



// WEBPACK FOOTER //
// ./src/pages/post/libraries/filter.tsx